module.exports = __webpack_public_path__ + "static/sounds/bloop.ogg";